import { render, staticRenderFns } from "./threevjia-i2i.vue?vue&type=template&id=2f650bc8"
import script from "./threevjia-i2i.vue?vue&type=script&lang=js"
export * from "./threevjia-i2i.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports